import {Component, Input, OnDestroy} from "@angular/core";
import {CustomerInstanceVenueModel} from "../customer-instance-venue.model";
import {AbstractControl, FormBuilder, FormGroup, Validators} from "@angular/forms";
import {FUISpinnersService} from "@fedelta-pos/ui";
import {ErrorHandlerService} from "../../../error-handler.service";
import {SalesHandoverService} from "./sales-handover.service";
import {Option, SalesHandoverData, SalesHandoverField} from "./sales-handover.data";
import {VenueContactData} from "../venue-contact/venue-contact.data";
import {BehaviorSubject, Subscription} from "rxjs";

@Component({
    selector: "fhm-sales-handover",
    templateUrl: "./sales-handover.component.html",
    styleUrls: ["./sales-handover.component.scss"],
    providers: [SalesHandoverService],
    standalone: false
})
export class SalesHandoverComponent implements OnDestroy {

    @Input() formGroupContact: FormGroup;

    VenueContactData = VenueContactData;

    editing: boolean;

    formGroup: FormGroup;

    subscriptions: Subscription = new Subscription();

    fields: SalesHandoverField[][];

    siteContact: VenueContactData = new VenueContactData();

    constructor(public model: CustomerInstanceVenueModel,
                private formBuilder: FormBuilder,
                private salesHandoverService: SalesHandoverService,
                private spinnersService: FUISpinnersService,
                private errorHandler: ErrorHandlerService) {
        this.subscriptions.add(model.data$.subscribe(() => {
            if (model.data.salesHandover) {
                if (!model.data.salesHandover.siteContact) {
                    model.data.salesHandover.siteContact = new VenueContactData();
                }
                this.siteContact = model.data.salesHandover.siteContact;
                const group: any = {};
                model.data.salesHandover.fields.forEach((field) => {
                    if (field.required) {
                        group[field.name] = ["", Validators.required];
                        if (!field.value) {
                            this.editing = true;
                        }
                    } else {
                        group[field.name] = [""];
                    }
                    if (field.type === "date" && field.value) {
                        field.value = <any>new Date(parseInt(field.value, 10));
                    }
                });
                this.formGroup = formBuilder.group(group);
                model.data.salesHandover.fields.filter(field => field.required).forEach((field) => {
                    this.formGroup.get(field.name)["required$"] = new BehaviorSubject(true);
                });

                this.fields = [];
                for (let n = 0; n < model.data.salesHandover.fields.length; n++) {
                    if ((n + 1) < model.data.salesHandover.fields.length) {
                        this.fields.push([model.data.salesHandover.fields[n], model.data.salesHandover.fields[n + 1]]);
                    } else {
                        this.fields.push([model.data.salesHandover.fields[n]]);
                    }
                    n = n + 1;
                }
            }
        }));
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    edit(): void {
        this.editing = true;
    }

    cancelEdit(): void {
        this.editing = false;
        this.model.refresh();
    }

    async save(): Promise<void> {
        Object.keys((this.formGroup.controls)).forEach((key) => {
            this.formGroup.controls[key].markAsTouched();
            this.formGroup.controls[key].updateValueAndValidity();
        });

        if (this.formGroup.valid) {
            const saveData: SalesHandoverData = new SalesHandoverData();
            saveData.fields = this.model.data.salesHandover.fields.map(field => {
                const saveField: SalesHandoverField = new SalesHandoverField();
                saveField.id = field.id;
                if (<any>field.value instanceof Date) {
                    saveField.value = (<any>field.value).getTime().toString();
                } else {
                    saveField.value = field.value;
                }
                return saveField;
            });
            saveData.siteContact = this.siteContact;
            this.spinnersService.open();
            try {
                await this.salesHandoverService.updateSalesHandover(this.model.venueId, saveData);
                this.editing = false;
                await this.model.refresh();
            } catch (error) {
                this.errorHandler.handleErrorResponse(error);
            } finally {
                this.spinnersService.close();
            }
        }
    }

    changeDropDown(formControl: AbstractControl, field: SalesHandoverField, item: Option): void {
        field.value = item ? item.id : undefined;
        formControl.setValue(field.value);
    }

    getFieldOption(field: SalesHandoverField): Option {
        if (field.value) {
            return field.typeConfig.options.find(value => value.id === field.value);
        } else {
            return undefined;
        }
    }
}
